import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ResetPasswordValidationSchema } from "../schemas/resetPassword.schema";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface useResetPasswordProps {
  reset_password_token?: string;
  onSuccess?: (response: any) => void;
  onError?: (error: AxiosError) => void;
}

const useResetPassword = ({ reset_password_token, onSuccess, onError }: useResetPasswordProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['resetPassword'],
    mutationFn: async (form: ResetPasswordValidationSchema) => {
      return await privateAxios.put('/auth/password', {
        admin_user: {
          password: form.password,
          password_confirmation: form.confirmPassword,
          reset_password_token,
        },
      });
    },
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError,
  });
};

export default useResetPassword;
